
import { call, put, takeLatest } from "redux-saga/effects";
import {
  addPatientFailure,
  addPatientSuccess,
  deletePatientFailure,
  deletePatientSuccess,
  fetchAllPatientsFailure,
  fetchAllPatientsSuccess,
  fetchHistoryPatientsFailure,
  fetchHistoryPatientsSuccess,
  fetchPatientFailure,
  fetchPatientsFailure,
  fetchPatientsSuccess,
  fetchPatientSuccess,
  updatePatientFailure,
  updatePatientSuccess,
} from "./patientAction";
import {
  addPatientEffect,
  deletePatientEffect,
  editPatientEffect,
  historyPatientEffect,
  listPatient,
  listPatientEffect,
  ViewPatientEffect,
} from "./patientEffect";
import {
  ADD_PATIENT_REQUEST,
  DELETE_PATIENT_REQUEST,
  FETCH_ALL_LIST_PATIENTS_REQUEST,
  FETCH_LIST_PATIENTS_REQUEST,
  FETCH_PATIENT_REQUEST,
  HISTORY_PATIENTS_REQUEST,
  UPDATE_PATIENT_REQUEST,
} from "./patientType";

function* fetchPatientsSaga(action) {

  try {
    const response = yield call(listPatientEffect, action.payload);

    const patients = {
      ...response,
      headers: undefined 
    };
    yield put(fetchPatientsSuccess(patients));
  } catch (error) {
    yield put(fetchPatientsFailure(error.message));
  }
}
function* fetchAllPatientsSaga(action) {

  try {
    const response = yield call(listPatient, action.payload);

    const patients = {
      ...response,
      headers: undefined 
    };
    yield put(fetchAllPatientsSuccess(patients));
  } catch (error) {
    yield put(fetchAllPatientsFailure(error.message));
  }
}


function* fetchGHistoryPatientsSaga(action) {
  try {
    const patients = yield call(historyPatientEffect, action.payload);
    yield put(fetchHistoryPatientsSuccess(patients));
  } catch (error) {
    yield put(fetchHistoryPatientsFailure(error.message));
  }
}
function* fetchPatientSaga(action) {
  try {
    const patient = yield call(ViewPatientEffect, action.payload.patientId);
    
    yield put(fetchPatientSuccess(patient));
  } catch (error) {
    yield put(fetchPatientFailure(error.message));
  }
}

function* addPatientSaga(action) {
  try {
    const response = yield call(addPatientEffect, action.payload.patientData);
    const patientData = response.data || response;


    yield put(addPatientSuccess(patientData));
  } catch (error) {
 
    const backendMessage = error.response?.data?.message || error.message || "Login failed";
    yield put(addPatientFailure(backendMessage || 'Failed to add patient'));
  }
}

function* updatePatientSaga(action) {
  try {
    const updatedPatient = yield call(
      editPatientEffect,
      action.payload.patientId,
      action.payload.patientData
    );
    yield put(updatePatientSuccess(updatedPatient));
  } catch (error) {

    const backendMessage = error.response?.data?.message || error.message || "Login failed";
    yield put(updatePatientFailure(backendMessage|| 'Failed to Update patient'));
  }
}

function* deletePatientSaga(action) {
  try {
    yield call(deletePatientEffect, action.payload.patientId);
    yield put(deletePatientSuccess(action.payload.patientId));
  } catch (error) {
    yield put(deletePatientFailure(error.message));
  }
}

export function* PatientSagas() {
  yield takeLatest(FETCH_LIST_PATIENTS_REQUEST, fetchPatientsSaga);
  yield takeLatest(FETCH_PATIENT_REQUEST, fetchPatientSaga);
  yield takeLatest(ADD_PATIENT_REQUEST, addPatientSaga);
  yield takeLatest(UPDATE_PATIENT_REQUEST, updatePatientSaga);
  yield takeLatest(DELETE_PATIENT_REQUEST, deletePatientSaga);
  yield takeLatest(HISTORY_PATIENTS_REQUEST, fetchGHistoryPatientsSaga);
  yield takeLatest(FETCH_ALL_LIST_PATIENTS_REQUEST, fetchAllPatientsSaga);
}
